import React           from 'react';
import LangSelector    from '../LangSelector';
import { makeStyles }  from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
    root: {
        height:     100,
        display:    'flex',
        marginLeft: 30
    }
}))

type LangMenuProps = {
    size:       number[];
    wideScreen: boolean;
    lang:       string;
    setLang:    (val: string) => void;
}

const LangMenu: React.FC<LangMenuProps> = ({ size, wideScreen, lang, setLang }) => {

  const classes = useStyles();

  const rootStyle = React.useMemo(() => {
    return {
       width: wideScreen ? '50vw' : (size[0] - 55)/2
    }
  },[size, wideScreen])

  return (
    <div 
       className = { classes.root }
       style     = { rootStyle }
    >
        <LangSelector
           variant = { lang === 'heb' ? 'arab' : 'heb' }
           lang    = { lang }
           setLang = { setLang }
        />
    </div>
  );
}



export default LangMenu;
